import { useState, useEffect } from 'react';
import { cookieService } from '../services/cookieService';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';

const COOKIE_NAME = 'confidentiality_accepted';

export const ConfidentialityWarning = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookie = cookieService.getCookie(COOKIE_NAME);
    if (!cookie) {
      setIsVisible(true);
    } else {
      // Refresh the cookie's TTL
      cookieService.setCookie(COOKIE_NAME, 'true', 7);
    }
  }, []);

  const handleAccept = () => {
    cookieService.setCookie(COOKIE_NAME, 'true', 7);
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/80 backdrop-blur-lg flex items-center justify-center z-[100] p-4"
        >
          <div className="modal-panel max-w-lg text-center" role="dialog" aria-modal="true" aria-labelledby="confidentiality-title">
            <span className="icon-tile icon-tile-lg icon-tile-amber mx-auto mb-4">
              <ShieldAlert className="w-5 h-5" />
            </span>
            <h1 id="confidentiality-title" className="text-xl font-semibold tracking-tight text-white">Confidentiality Notice</h1>
            <p className="text-sm text-glass-300 mt-3 leading-relaxed">
              The information contained within this administration panel is confidential and proprietary.
              Unauthorized access, use, or distribution of this information is strictly prohibited.
              Do not share screenshots or any data from this site with unauthorized individuals.
            </p>
            <button
              onClick={handleAccept}
              className="btn-primary mt-6 px-6"
            >
              I Understand and Agree
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
